const KEY_PREFIX = 'ff.';

export function getRawFlag(flagId: string): string | null {
    return localStorage.getItem(KEY_PREFIX + flagId);
}

export function setRawFlag(flagId: string, value: string): void {
    localStorage.setItem(KEY_PREFIX + flagId, value);
}

export function getFlag(flagId: string): boolean | null {
    const value = getRawFlag(flagId);

    if (value === null) {
        return null;
    }

    return value === 'true';
}

export function setFlag(flagId: string, value: boolean): void {
    setRawFlag(flagId, String(value));
}
